import React from 'react';
import Button from 'rsuite/Button';
import Checkbox from 'rsuite/Checkbox';
import CartPayments from '../CartPayments';
import { useEventEmitter } from 'hooks';
import { useDispatch, useSelector } from 'react-redux';
import * as OrderActions from 'store/order/orderSlice';
import * as OrderSelectors from 'store/order/orderSelectors';
import * as ProjectActions from "../../../store/project/projectSlice";
import {isPromoCode} from '../../Cart';
import {isNewCustomer, isPromoCodeVisible} from "../../Page/PageForm";

export  {isPromoCodeTextOk};

let isPromoCodeTextOk = false;
export default function CartFooter({
  eta,
  checklist,
  payments,
  total,
  pagesIsNotExists,
  optionsWithPrice,
  pagesIsExists,
  isButtonOnLeft,
  isCartPaymentsHidden,
  buttonText
}) {
  let isQuoteText = (optionsWithPrice <= 0 && ( pagesIsNotExists)) || (!total && pagesIsExists);
  const orderInformation = useSelector(OrderSelectors.selectOrderInformation);
  const orderIsProcessing = useSelector(OrderSelectors.selectOrderIsProcessing);
  const errors = useSelector(OrderSelectors.orderInformationErrors);
  const events = useEventEmitter();
  const dispatch = useDispatch();

  const onChange = (name, checked) => {
    events.emit('Form:Change', { name, checked });
  };

  const onSubmit = () => {
    dispatch(OrderActions.setOrderTotal(total));
    dispatch(OrderActions.setOrderEta(eta));
    dispatch(OrderActions.setOrderChecklist(checklist));
    events.emit('Form:Submit');
  };
  const onPromoCode = (values) => {
    if (!isPromoCodeVisible) {
      return;
    }

    if ((values.target.value === '50OFF') ||(values.target.value === '50off')) {
      isPromoCodeTextOk = true;
    } else {
      isPromoCodeTextOk = false;
    }

    if (isPromoCodeTextOk && isNewCustomer) {
      isPromoCode = true;
    } else {
      isPromoCode = false;
    }

    dispatch(ProjectActions.setChecklistOptions(values));
    dispatch(ProjectActions.setChecklistOptionsChecked());
    dispatch(ProjectActions.setChecklistOptionsDisabled());
  };

  return (
    <div className="app-cart-footer">
      <div className="app-cart-footer-checkboxes">
        <Checkbox
          className={`${errors?.isConsentProcessing ? 'invalid' : ''}`}
          checked={orderInformation.isConsentProcessing}
          value="isConsentProcessing"
          onChange={onChange}>
          <div className="app-cart-footer-checkboxes-text">
            I consent to the processing of my personal data and agree to the&nbsp;
            <a href="/privacy-policy.html" target="_blank" rel="noreferrer">Privacy Policy</a> and the&nbsp;
            <a href="/terms-and-conditions.html" target="_blank" rel="noreferrer">Terms &amp; Conditions</a>.
           {errors?.isConsentProcessing && (<span className="app-cart-footer-checkboxes-error">Please confirm that you agree to the Privacy Policy.</span>)}
          </div>
        </Checkbox>
        {!isButtonOnLeft && (<Checkbox
          checked={orderInformation.isShowcaseProject}
          value="isShowcaseProject"
          onChange={onChange}>
          <div className="app-cart-footer-checkboxes-text">I’m OK to showcase my project.</div>
        </Checkbox>)}
      </div>

      {!isButtonOnLeft && isPromoCodeVisible && (
          <div className="app-cart-footer-promocode field">
            <label htmlFor="promocode">Enter your promo code</label>
            <input type="text" name="promocode" onChange={onPromoCode}/>
            <div className={`promocode-error ${(!isNewCustomer && isPromoCodeTextOk) ? 'is-visible' : ''}`}>
              This promo code is valid for new clients only. If you have any questions contact our support team.
            </div>
          </div>
      )}

      {!isButtonOnLeft && !isCartPaymentsHidden && (<CartPayments payments={payments} />)}

      <div className="app-cart-button-wrapper">
        <Button
            appearance="default"
            className="app-cart-button"
            disabled={orderIsProcessing}
            data-estimate="true"
            block
            onClick={onSubmit}>
          {buttonText ? buttonText : isQuoteText ? 'GET A FREE QUOTE' : 'ORDER NOW' }
        </Button>
        <div className="app-cart-button-overlay"></div>
      </div>
    </div>
  )
}
